<template>
  <div v-if="object_created">
    <v-row>
      <v-col class="py-0" cols="12" md="8">
        <v-file-input
          accept="image/*"
          :placeholder="currentFilename || placeholder || $t('form.researchArea.image')"
          prepend-icon="mdi-camera"
          v-model="model"
          v-on:change="preview_image($event)"
        ></v-file-input>
      </v-col>
      <v-col class="d-flex justify-center" md="4">
        <a
          v-if="new_url !== ''"
          :href="new_url"
          target="_blank"
          rel="noopener"
        >
          <v-img
            :src="new_url"
            :max-width="imageMaxWidth"
            :max-height="imageMaxHeight"
          ></v-img>
        </a>
      </v-col>
    </v-row>
  </div>
  <v-row v-else>
    <v-col cols="12" md="6">
      <v-alert
        v-if="info_text"
        dense
        text
        type="info"
        class="text-center mb-0"
      >
        {{ info_text }}
      </v-alert>
      <v-alert
        dense
        text
        type="info"
        class="text-center mb-0"
        v-if="name_field === 'logo'"
      >
        {{ $t("form.organization.files.info") }}
      </v-alert>
      <v-alert
        dense
        text
        type="info"
        class="text-center mb-0"
        v-if="name_field === 'picture_website'"
      >
        {{ $t("form.account_file_info") }}
      </v-alert>
      <v-alert
        dense
        text
        type="info"
        class="text-center mb-0"
        v-if="name_field === 'image'"
      >
        {{ $t("form.project.image_info") }}
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadImage",

  props: {
    object_created: Boolean,
    object: Object,
    path: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    name_field: String,
    placeholder: {
      type: String,
      default: ""
    },
    info_text: {
      type: String,
      default: ""
    },
    imageMaxWidth: {
      type: Number,
      default: 80
    },
    imageMaxHeight: {
      type: Number,
      default: 80
    }
  },
  data() {
    return {
      model: null,
      new_url: this.url || ""
    };
  },
  computed: {
    currentFilename() {
      const name = this.object && this.object.name;
      return name ? name.split("/").pop() : "";
    }
  },
  watch: {
    url: {
      immediate: true,
      handler(val) {
        this.new_url = val || "";
      }
    }
  },

  methods: {
    preview_image(file) {
      if (file && !(typeof Blob !== "undefined" && file instanceof Blob)) {
        return;
      }
      if (file) {
        this.new_url = URL.createObjectURL(file);
      } else {
        this.new_url = "";
      }
      this.saveImage();
    },

    saveImage() {
      if (typeof this.model !== "string") {
        let formData;
        if (this.model !== undefined && this.model !== null) {
          formData = new FormData();
          formData.append(this.name_field, this.model);
        } else {
          formData = {};
          formData[this.name_field] = null;
        }
        axios
          .patch(this.path, formData)
          .then(response => {
            this.$emit("uploaded", {
              field: this.name_field,
              url: response.data[this.name_field] || ""
            });
          })
          .catch(error => {
            this.$store.commit("alert", {
              color: "error",
              text: error.response.data
            });
          });
      }
    }
  }
};
</script>

<style scoped></style>
